var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrivacyPolicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.907 871.236h2.56l9.387-5.12c7.68-4.267 18.773-10.667 32.427-19.2 34.513-21.44 67.196-45.705 97.707-72.533 70.4-61.013 147.627-154.88 147.627-271.36v-240.641c0.030-6.529-1.963-12.907-5.709-18.256-3.742-5.349-9.054-9.405-15.198-11.611l-272.213-102.4c-3.511-1.479-7.283-2.24-11.093-2.24s-7.582 0.762-11.093 2.24l-273.066 102.4c-6.145 2.205-11.456 6.262-15.2 11.611s-5.738 11.727-5.707 18.256v238.934c0 116.48 77.227 210.347 147.627 271.36 30.512 26.829 63.192 51.093 97.706 72.533 13.653 8.533 24.747 14.933 32.427 19.2l9.387 5.12h2.56zM503.040 869.53c4.484 2.317 9.459 3.529 14.507 3.529s10.022-1.212 14.507-3.529zM759.467 501.316c0 88.32-59.307 165.12-125.44 223.573-28.318 24.256-58.411 46.362-90.027 66.133l-25.6 15.36-25.6-15.36c-31.599-19.635-61.692-41.6-90.026-65.707-66.133-58.88-125.44-135.68-125.44-224v-216.748l241.066-90.453 241.067 90.453v216.748z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacyPolicy);
export default __webpack_public_path__ + "static/media/icon-privacy-policy.946258bb70fa1ca2a24892e411e458e8.svg";
export { ForwardRef as ReactComponent };